import ClaimApiProcessor from '../../processors/claim-api-processor.js'
import ClaimStatusComponent from '../../components/claim-status'
import { formatDate } from '@lib/utils/format-date'

const TABLE_FILTERS = [
  {
    attribute: 'number',
    label: 'Claim No',
    type: 'string',
    icon: 'el-icon-document',
    customComparisons: {
      partial: 'contains',
    },
  },
  {
    attribute: 'createdBy.firstName',
    label: 'Created by',
    type: 'string',
    icon: 'el-icon-user',
  },
  {
    attribute: 'createdAt',
    label: 'Date Created',
    type: 'date',
    icon: 'el-icon-date',
  },
  {
    attribute: 'firstName',
    label: 'First Name',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'lastName',
    label: 'Last Name',
    type: 'string',
    icon: 'el-icon-document',
  },
  {
    attribute: 'itce',
    label: 'ITCE',
    type: 'numeric',
    icon: 'el-icon-document',
  },
  {
    attribute: 'amount',
    label: 'Amount',
    type: 'numeric',
    icon: 'el-icon-money',
  },
  {
    attribute: 'status',
    label: 'Status',
    icon: 'el-icon-check',
    type: 'select',
    values: [
      {
        label: 'Pending',
        value: 'created',
      },
      {
        label: 'Code sent',
        value: 'code_sent',
      },
      {
        label: 'Failed',
        value: 'failed',
      },
      {
        label: 'Redeemed',
        value: 'redeemed',
      },
      {
        label: 'Frozen',
        value: 'frozen',
      },
      {
        label: 'Revoked',
        value: 'revoked',
      },
    ],
  },
]

const TABLE_COLUMNS = [
  {
    name: 'number',
    label: 'Claim No.',
    icon: 'el-icon-document',
    width: 100,
  },
  {
    name: 'createdAt',
    label: 'Created by',
    icon: 'el-icon-user',
    width: 250,
    format(_, row) {
      const {
        createdAt,
        createdBy: { firstName, lastName },
      } = row
      const date = formatDate(createdAt, 'DD/MM/YYYY hh:mma')

      return `${firstName} ${lastName}\xa0\xa0\xa0${date}`
    },
  },
  {
    name: 'firstName',
    label: 'First Name',
    icon: 'el-icon-document',
    width: 120,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    icon: 'el-icon-document',
    width: 120,
  },
  {
    name: 'itce',
    label: 'ITCE',
    icon: 'el-icon-document',
    width: 80,
    format(value) {
      return `${value}%`
    },
  },
  {
    name: 'amount',
    label: 'Amount',
    icon: 'el-icon-money',
    format: 'dollar',
    width: 90,
  },
  {
    name: 'status',
    label: 'Status',
    icon: 'el-icon-check',
    width: 120,
    component: (_, __, { row }) => ({
      is: ClaimStatusComponent,
      props: { value: row.status, frozen: row.frozen },
    }),
  },
]

function dataQueryTransformer(dataQuery) {
  let { filters } = dataQuery
  const mixinFilters = []

  // There is no status: 'frozen' but there is frozen: true
  filters.forEach((f, fIndex) => {
    if (f.attribute === 'status') {
      const frozenValueIdx = f.value.indexOf('frozen')

      if (frozenValueIdx === -1) {
        return
      }

      f.value.splice(frozenValueIdx, 1)

      mixinFilters.push({
        attribute: 'frozen',
        type: 'boolean',
        comparison: 'eq',
        value: true,
      })
    }
  })

  // if 'Frozen' was the only checked item
  // then we remove the entire filter
  filters = filters.filter(f => f.value.length)

  dataQuery.filters = filters.concat(mixinFilters)

  return dataQuery
}

export default component => ({
  processor: new ClaimApiProcessor({
    component,
    path: 'claims',
    dataQueryTransformer,
  }),
  filters: TABLE_FILTERS,
  columns: TABLE_COLUMNS,
  tableName: 'claims',
})
